import moment from "moment";
import { Calendar } from "PFTypes";

const getCalendarsUsedWithinRange = (
  calendars: { [key: string]: Calendar },
  startDate: string,
  endDate: string
) => {
  const calendarsWithinRange = Object.keys(calendars).filter(
    (date) => moment.utc(date).unix() < moment.utc(endDate).unix()
  );
  const firstCalStartingWithinRange = calendarsWithinRange.findIndex(
    (date) => moment.utc(date).unix() > moment(startDate).unix()
  );
  return firstCalStartingWithinRange === -1
    ? [calendarsWithinRange[calendarsWithinRange.length - 1]]
    : calendarsWithinRange.slice(firstCalStartingWithinRange - 1);
};

export default getCalendarsUsedWithinRange;
